// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { retailchoice as baseRetailChoiceTheme } from "@stepstone-genesis/design-tokens";
var retailchoice = extendBaseTheme("retailchoice", baseRetailChoiceTheme);
export {
  retailchoice
};
